import { IconProps } from "@/types/common";
import React from "react";

const CategoryIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.79352 9.85229L12.0306 1.38889L17.2689 9.85479L6.79352 9.85229ZM19.0189 23.6099C17.697 23.6099 16.577 23.1592 15.659 22.2579C14.741 21.3565 14.2819 20.2559 14.2819 18.956C14.2819 17.6562 14.741 16.5518 15.659 15.643C16.577 14.7341 17.697 14.2797 19.0189 14.2797C20.3407 14.2797 21.4645 14.7341 22.3902 15.643C23.3158 16.5518 23.7782 17.6562 23.7774 18.956C23.7765 20.2559 23.3141 21.3565 22.3902 22.2579C21.4662 23.1592 20.3424 23.6103 19.0189 23.6111M1.55518 22.9858V14.9038H9.77922V22.9858H1.55518Z" />
    </svg>
  );
};

export default CategoryIcon;
